<template>
	<footer class="bg-primary-dark text-white">
		<div class="max-w-7xl mx-auto px-6 py-12 lg:py-16">
			<!-- Main Footer Content -->
			<div class="grid grid-cols-1 md:grid-cols-12 gap-8">
				<!-- Brand Section -->
				<div class="md:col-span-6 lg:col-span-6">
					<div class="flex items-center gap-3 mb-4">
						<div class="text-2xl font-semibold opacity-90">
							Nexus
						</div>
						<div class="text-2xl font-extrabold text-white">
							Insurance
						</div>
					</div>
					<p class="text-text-secondary max-w-xl">
						A platform to access various insurance products. We help
						you find tailored coverage, simple pricing and expert
						support.
					</p>
				</div>

				<!-- Explore Links -->
				<div class="md:col-span-2 lg:col-span-2">
					<h4
						class="text-sm font-semibold text-text-secondary mb-3 uppercase"
					>
						Explore
					</h4>
					<ul class="space-y-2 text-text-secondary">
						<li>
							<router-link
								to="/insurance"
								class="hover:text-white"
								>Products</router-link
							>
						</li>
						<li>
							<router-link to="/about-us" class="hover:text-white"
								>How it works</router-link
							>
						</li>
					</ul>
				</div>

				<!-- Company Links -->
				<div class="md:col-span-2 lg:col-span-2">
					<h4
						class="text-sm font-semibold text-text-secondary mb-3 uppercase"
					>
						Company
					</h4>
					<ul class="space-y-2 text-text-secondary">
						<li>
							<router-link
								to="/contactus"
								class="hover:text-white"
								>Contact Us</router-link
							>
						</li>
					</ul>
				</div>

				<!-- Contact Section -->
				<div class="md:col-span-2 lg:col-span-2">
					<h4
						class="text-sm font-semibold text-text-secondary mb-3 uppercase"
					>
						Contact
					</h4>
					<p class="text-text-secondary">
						Call:
						<a
							href="tel:0723350348"
							class="text-white hover:underline"
							>0723 350 348</a
						>
					</p>
					<p class="text-text-secondary whitespace-nowrap">
						Email:
						<a
							href="mailto:corporate@nexus.ke"
							class="text-white hover:underline"
							>corporate@nexus.ke</a
						>
					</p>

					<!-- Social Media Links -->
					<div class="mt-4 flex items-center gap-3">
						<a
							aria-label="Facebook"
							href="https://facebook.com"
							class="w-9 h-9 rounded-md bg-[#3a3c4c] flex items-center justify-center hover:bg-blue-600 transition-colors"
						>
							<i class="fab fa-facebook-f"></i>
						</a>
						<a
							aria-label="YouTube"
							href="https://youtube.com"
							class="w-9 h-9 rounded-md bg-[#3a3c4c] flex items-center justify-center hover:bg-red-600 transition-colors"
						>
							<i class="fab fa-youtube"></i>
						</a>
						<a
							aria-label="Instagram"
							href="https://instagram.com"
							class="w-9 h-9 rounded-md bg-[#3a3c4c] flex items-center justify-center hover:bg-pink-500 transition-colors"
						>
							<i class="fab fa-instagram"></i>
						</a>
						<a
							aria-label="Twitter"
							href="https://twitter.com"
							class="w-9 h-9 rounded-md bg-[#3a3c4c] flex items-center justify-center hover:bg-sky-400 transition-colors"
						>
							<i class="fab fa-twitter"></i>
						</a>
					</div>
				</div>
			</div>

			<!-- Bottom Footer Section -->
			<div class="border-t border-white/10 mt-10 pt-8">
				<div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
					<!-- Copyright -->
					<div class="md:col-span-1">
						<p class="text-text-secondary text-sm">
							&copy; {{ new Date().getFullYear() }} Nexus
							Insurance. All rights reserved.
						</p>
					</div>

					<!-- Terms Link -->
					<div class="md:col-span-1 flex items-center justify-center">
						<div class="text-text-secondary text-sm">
							<router-link to="/terms" class="hover:text-white"
								>Terms & Conditions</router-link
							>
						</div>
					</div>

					<!-- Newsletter Subscription -->
					<div class="md:col-span-1 flex items-center justify-end">
						<form
							@submit.prevent="subscribe"
							class="flex gap-3 w-full max-w-md"
						>
							<label for="email" class="sr-only"
								>Email address</label
							>
							<input
								id="email"
								v-model="email"
								type="email"
								placeholder="Your email"
								class="flex-1 px-4 py-2 rounded-md bg-surface text-text-primary placeholder:text-text-secondary border border-border focus:outline-none focus:ring-2 focus:ring-primary/30"
							/>
							<button
								type="submit"
								class="px-4 py-2 rounded-md bg-primary text-white font-semibold hover:bg-primary-light transition-colors"
							>
								Subscribe
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'AppFooter',
	data() {
		return {
			email: '',
		};
	},
	methods: {
		subscribe() {
			if (!this.email) return;

			console.log('Subscribed:', this.email);
			this.email = '';
		},
	},
};
</script>

<style scoped></style>
